import { UserProfile, Household, SafetyMode, Role, RoleView } from '@/types';
import { useMemo } from 'react';

export function useRoleView(user: UserProfile | null, household: Household | null): RoleView {
  return useMemo(() => {
    if (!user || !household) return 'member';

    // SafetyMode.STRICT takes precedence
    if (user.safetyMode === SafetyMode.STRICT) return 'child';

    const permission = household.permissions[user.id];
    if (!permission) return 'member';

    if ((user as any).role === Role.ADMIN || (user as any).role === Role.OWNER) return 'admin';

    const member = household.members?.find(m => m.userId === user.id);
    if (member?.role === Role.ADMIN || member?.role === Role.OWNER) return 'admin';
    if (member?.role === Role.MEMBER) return 'member';

    return 'member';
  }, [user, household]);
}
